import { useEffect } from 'react';

/* Título de la pestaña. No se restaura al salir: cada página pone el suyo
   (el <head> inicial de cada ruta lo genera scripts/prerender.mjs). */
export default function useDocumentTitle(title) {
  useEffect(() => { document.title = title; }, [title]);
}
